import { render, staticRenderFns } from "./zuBu.vue?vue&type=template&id=16486713&scoped=true&"
import script from "./zuBu.vue?vue&type=script&lang=js&"
export * from "./zuBu.vue?vue&type=script&lang=js&"
import style0 from "./zuBu.vue?vue&type=style&index=0&id=16486713&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16486713",
  null
  
)

export default component.exports